import React from 'react';
import { hsdReportID, powerBIBase } from '../../../config/PowerBiReportConfig';
import { appBaseURL } from '../../../config/URLConfig';

export const HSDReport = ({ username }) => {

    const handleViewReportClick = () => {
        window.open(`${powerBIBase}${hsdReportID}/ReportSection`);
    }

    const handleDownloadExcelClick = () => {
        window.open(`${appBaseURL}/api/hsd-report?username=${username}`);
    }

    return (
        <div>
            <h2 className="report-header">HSD Report</h2>
            <div className="report-button-container">
                <div className={"report-button"} onClick={handleViewReportClick}>
                    HSD Report
                </div>
                <div className={"report-button"} onClick={handleDownloadExcelClick}>
                    Download Excel
                </div>
            </div>
        </div>
    );
}
